import React from 'react';
// Core Components
import ModalUI from "../ModalsUI/index";
import HeaderDefault from "../HeadersUI/HeaderDefault";
import HeaderVariantSwitch from "../HeadersUI/HeaderVariantSwitch";
import FooterDefault from "../FootersUI/FooterDefault";
import ExitBtn from '../ButtonsUI/ExitBtn';
import TempLoadingScreen from '../LoadingController/TempLoadingScreen';
import ControllsUI from "../ControlsUI";
import { useStore } from "../../zustand";

export default function DefaultTheme() {
    const { controls_ui } = useStore.getState().scene_controls;
    const { variant_switch_ui } = useStore.getState().settings; // deprecated

    return (
        <React.Fragment>
            <ModalUI />
            <ExitBtn />
            { variant_switch_ui ? <HeaderVariantSwitch /> : <HeaderDefault /> }
            { controls_ui && <ControllsUI /> }
            <FooterDefault />
            <TempLoadingScreen />
        </React.Fragment>
    );
}